import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Message } from 'primereact/message';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login, isLoading, authError, clearAuthError } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearAuthError();
    
    const result = await login(formData.username, formData.password, formData.rememberMe);
    
    if (result.success) {
      navigate('/dashboard');
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="se-auth-container">
      <div className="se-auth-card">
        <div className="se-auth-header">
          <h1 className="se-auth-title">Sport Endurance Members Portal</h1>
        </div>

        <form onSubmit={handleSubmit}>
          {authError && (
            <Message
              severity="error"
              text={authError}
              className="w-full mb-3"
            />
          )}

          <div className="se-form-group">
            <label htmlFor="username" className="se-form-label">
              Username/Email<span className="se-form-required">*</span>
            </label>
            <InputText
              id="username"
              value={formData.username}
              onChange={(e) => handleInputChange('username', e.target.value)}
              placeholder="Enter your username or email"
              className="w-full"
              required
            />
          </div>

          <div className="se-form-group">
            <label htmlFor="password" className="se-form-label">
              Password <span className="se-form-required">*</span>
            </label>
            <Password
              id="password"
              value={formData.password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              placeholder="Enter your password"
              className="w-full"
              inputClassName="w-full"
              feedback={false}
              toggleMask
              required
            />
          </div>

          <div className="flex align-items-center justify-content-between mb-4">
            <div className="flex align-items-center">
              <Checkbox
                inputId="rememberMe"
                checked={formData.rememberMe}
                onChange={(e) => handleInputChange('rememberMe', e.checked)}
              />
              <label htmlFor="rememberMe" className="ml-2 cursor-pointer">
                Remember me
              </label>
            </div>
            <Link to="https://www.sportendurance.co.uk/forgotten-password" className="se-text-primary font-medium">
              Forgot Password?
            </Link>
          </div>

          <Button
            type="submit"
            label="Sign In"
            loading={isLoading}
            className="w-full p-button-primary mb-3"
            size="large"
          />

          <div className="text-center">
            <span className="text-600">Don't have an account? </span>
            <Link to="https://www.sportendurance.co.uk/create-new-account" className="se-text-primary font-medium">
              Register here
            </Link>
          </div>
        </form>

      </div>
    </div>
  );
};

export default Login;